import { use, useEffect } from "react";
import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";

import { close, open } from "../redux/popupSlice";
import * as APIS from "../utils/service";
import { useNavigate } from "react-router-dom";
import { setModalState } from "../redux/communityStepSlice";

// 신청 상태 화면
const GatheringFinish = ({ innerStep, setInnerStep, setStep }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { configdata } = useSelector(s => s.configReducer);
    const { modalState } = useSelector((s) => s.communityStepReducer);

    const [detailInfo, setDetailInfo] = useState({});

    const [isSuccess, setIsSuccess] = useState(false);
    const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
    const isTablet = useMediaQuery({
        query: "(min-width: 768px) and (max-width: 1024px)",
    });
    const isDesktop = useMediaQuery({ query: "(min-width: 1025px)" });

    const loadInfo = () => {
        APIS.postData('/v1/communityGroup/get', {}).then(({ data }) => {
            setDetailInfo(data)
        }).catch(({ response }) => {
            const { data } = response;
            dispatch(
                open({
                    component: data?.msg || "잠시후 다시 시도해주세요.",
                    title: '알림',
                    button: "확인",
                    titleviewer: true,
                    alert: false,
                    onPress: () => {
                        dispatch(close());
                    },
                })
            );
        })
    }

    // 카테고리 이름 변경 
    const cateToName = (type = 1, idx = 1) => {
        if (type === 1) {
            let findCate = configdata?.consts?.communityCategory1?.find(v => v?.idx == idx);
            if (findCate) {
                return findCate?.title
            }
        } else if (type === 2) {
            let findCate = configdata?.consts?.communityCategory2?.find(v => v?.idx == idx);
            if (findCate) {
                return findCate?.title
            }
        }
        return ""
    }

    // 메인 소모임 창으로 이동
    const goMainStep = () => {
        setStep(1)
        setInnerStep(1);
    }

    useEffect(() => {
        loadInfo();
    }, [])

    return (
        <div
            className="community_modal_white_wrap"
            style={{
                justifyContent: "space-between",
            }}
        >
            <div className="community_modal_inner_wrap">
                {/* 심사상태에 따른 처리 1=심사중 9=거절*/}
                {innerStep === 3 ? <>
                    {detailInfo?.status == 1 && (
                        <div className="community_modal_inner_header">
                            <p className="title">검토중입니다.</p>
                            <div className="modal_inner_div">
                                <p>
                                    개설이 완료되면 홈페이지 내 알림을 통해
                                    알려드리겠습니다.
                                </p>
                                <p>
                                    *1인당 최대 n개의 소모임을 생성할 수 있으며,
                                    동시 개설 신청은 불가능합니다.
                                </p>
                            </div>
                        </div>
                    )}
                    {detailInfo?.status == 9 && (
                        <div className="community_modal_inner_header">
                            <p className="title red">
                                신규 소모임 신청이 거절되었습니다.
                            </p>
                            <div className="modal_inner_div">
                                <p>거절 사유</p>
                                <p style={{ whiteSpace: "pre-line" }}>
                                    {detailInfo?.no_desc}
                                </p>
                            </div>
                        </div>
                    )}

                    {/* 거절상태일 경우 */}
                    {detailInfo?.status == 9 && (
                        <div className="bottom_btn_wrap">
                            <button className="register" onClick={() => {
                                setStep(2)
                                setInnerStep(1, detailInfo);
                            }}>
                                {isMobile ? "재신청" : "수정 후 재신청"}
                            </button>
                            <button className="edit" onClick={() => {
                                goMainStep();
                                navigate('/Contactus')
                            }}>
                                {isMobile ? "문의" : "문의하기"}
                            </button>
                        </div>
                    )}
                </> : <>
                    <div className="community_modal_inner_header">
                        <p className="title">이전 신청 내용</p>
                        <div className="modal_inner_div">
                            <p>
                                소모임 신청 내역이 있을경우 신규 신청할 수 없습니다.
                            </p>
                        </div>
                    </div>
                </>}


                <div className="community_modal_inner_content">
                    <p>신청내용</p>
                    <div className="community_modal_inner_table">
                        <table>
                            <tbody>
                                <tr>
                                    <td>카테고리</td>
                                    <td>
                                        {/* 대 카테고리 -소 카테고리 (대 카테고리기반) */}
                                        {cateToName(1, detailInfo?.cate1)} - {cateToName(2, detailInfo?.cate2)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>소모임명</td>
                                    <td>{detailInfo?.title}</td>
                                </tr>
                                <tr>
                                    <td>목적</td>
                                    <td>
                                        {detailInfo?.desc}
                                    </td>
                                </tr>
                                <tr>
                                    <td>가입방식</td>
                                    <td>{configdata?.consts?.communityJoinType?.find(v => v.idx == detailInfo?.join_type)?.title}</td>
                                </tr>
                                <tr>
                                    <td>최대인원</td>
                                    <td>{detailInfo?.max_count}명</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="bottom_btn_wrap">
                <button
                    className="cancel"
                    onClick={() => {
                        goMainStep();
                    }}
                >
                    닫기
                </button>
            </div>
        </div>
    );
};

export default GatheringFinish;
